import { useDrop } from 'react-dnd';
import {
  Assignment,
  SeverityName,
  DragItem
} from 'store/ducks/InternalControls/types';
import { CloseOutlined } from '@ant-design/icons';
import * as Styled from './InternalControlsDND.styled';

export const RiskInsideBpr: React.FC<{
  risk: Assignment;
  severity?: SeverityName | null;
  assignments: Assignment[];
  onDropControl: (riskInstanceId: string, item: DragItem) => void;
  onDeleteAssignment: (id: string) => void;
}> = ({ risk, severity, assignments, onDropControl, onDeleteAssignment }) => {
  const [{ isOver }, dropRef] = useDrop<DragItem, void, { isOver: boolean }>(
    () => ({
      accept: 'ITEM',
      canDrop: (item) => item.itemType === 'CONTROL',
      drop: (item, monitor) => {
        if (monitor.didDrop()) return;
        if (item.itemType !== 'CONTROL') return;
        if (risk.riskInstanceId) {
          onDropControl(risk.riskInstanceId, item);
        }
      },
      collect: (monitor) => {
        const item = monitor.getItem<DragItem>();
        return {
          isOver:
            monitor.isOver({ shallow: true }) && item?.itemType === 'CONTROL'
        };
      }
    })
  );

  const controlUnderThisRisk = assignments.filter(
    (a) =>
      a.riskInstanceId === risk.riskInstanceId && a.sourceType === 'CONTROL'
  );

  return (
    <Styled.LinkedItem ref={dropRef} isOver={!!isOver} severity={severity}>
      <div>
        <strong>{risk.text}</strong>
        <Styled.DeleteButton
          onClick={() => onDeleteAssignment(risk.assignmentId)}
        >
          <CloseOutlined />
        </Styled.DeleteButton>
      </div>

      {controlUnderThisRisk.map((ctrl) => (
        <Styled.NestedControl
          key={ctrl.assignmentId}
          isOver={false}
          controlStatus={ctrl.control_status}
        >
          {ctrl.text}

          <Styled.DeleteButton
            onClick={() => onDeleteAssignment(ctrl.assignmentId)}
          >
            <CloseOutlined />
          </Styled.DeleteButton>
        </Styled.NestedControl>
      ))}
    </Styled.LinkedItem>
  );
};
